import { useEffect, useRef, useState } from 'react';

export function Expandable({ title, children, defaultOpen = false, className = '' }: { title: string; children: React.ReactNode; defaultOpen?: boolean; className?: string }) {
  const [open, setOpen] = useState(defaultOpen);
  const [height, setHeight] = useState<number | undefined>(undefined);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => { if (ref.current) setHeight(ref.current.scrollHeight); }, [children]);
  return (
    <button onClick={() => setOpen(!open)} className={`card relative rounded-2xl px-4 py-3 transition-all duration-300 ease-in-out ${className}`} aria-expanded={open}>
      <div className="group flex w-full items-center justify-between text-left">
        <h3 className="text-base font-medium text-type-800 transition-colors dark:text-neutral-100">{title}</h3>
        <div className="relative ml-4 flex h-8 w-8 flex-shrink-0 items-center justify-center">
          <span className={`absolute inset-0 flex items-center justify-center transition-transform duration-300 ease-in-out ${open ? '-rotate-[135deg]' : 'rotate-0'}`}>
            <span className="absolute h-4 w-0.5 rounded-full bg-type-600 dark:bg-neutral-400" />
            <span className="absolute h-0.5 w-4 rounded-full bg-type-600 dark:bg-neutral-400" />
          </span>
        </div>
      </div>
      <div className="overflow-hidden text-start text-sm transition-all duration-300 ease-in-out dark:text-neutral-300" style={{ maxHeight: open ? `${height}px` : '0px', marginTop: open ? '1rem' : '0', opacity: open ? 1 : 0 }}>
        <div ref={ref}>{children}</div>
      </div>
    </button>
  );
}
